import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('info', [
    'enabled',
    'selectedFiltersDate',
    'selectedFiltersDevice',
    'selectedFiltersCycle',
    'selectedFiltersActivity',
    'selectedFiltersDeviceState',
    'selectedFiltersDeviceStateHistory',
    'selectedFiltersEdge',
    'selectedFiltersInsights',
    'selectedFiltersInsightsDesigner',
    'selectedDetails',
    'selectedCompact',
  ]),
}

export const Methods = mapActions('info', ['setInfo', 'setCompact'])
